// Features/Accessories-Section/mod.ts
import { openCart, addItems } from "Cart";
import { Composite } from "Composite";
class FoldSelectEvent extends CustomEvent {
  constructor(selected) {
    super("Fold:Select", {
      bubbles: true,
      detail: { selected }
    });
  }
}
var Selector_Target = `.Accessories-Fold-Target`;
var Selector_Cart = `.Accessories-Summary-Cart`;
var Selector_Fold = `accessories-fold`;

class Section extends Composite {
  parts;
  constructor() {
    super();
    const folds_ = this.querySelectorAll(Selector_Fold);
    const folds = Array.from(folds_);
    const addToCart_ = this.querySelectorAll(Selector_Cart);
    const addToCart = Array.from(addToCart_);
    this.parts = { addToCart, folds };
    for (const button of this.parts.addToCart)
      button.addEventListener("click", this.addProductsToCart.bind(this));
    const targets_ = document.querySelectorAll(Selector_Target);
    const targets = Array.from(targets_);
    let selected = targets.at(0) ?? null;
    for (const target of Array.from(targets))
      target.addEventListener("click", () => {
        if (selected !== target) {
          selected?.dispatchEvent(new FoldSelectEvent(false));
          target.dispatchEvent(new FoldSelectEvent(true));
          selected = target;
          return;
        }
        target.dispatchEvent(new FoldSelectEvent(false));
        target.checked = false;
        selected = null;
      });
  }
  updateSelection() {
    this.dataset.selection = this.selectionType;
    const selected = this.selectedFolds;
    if (selected.length === 0) {
      this.dataset.firstSelection = "None";
      return;
    }
    if (selected.length === 1) {
      this.dataset.firstSelection = selected[0].dataset.collection;
      return;
    }
  }
  get selectedFolds() {
    return this.parts.folds.filter((fold) => fold.dataset.isAnySelected === "true");
  }
  get selectionType() {
    const selected = this.selectedFolds;
    if (this.parts.folds.length === selected.length)
      return "All";
    if (selected.length > 1)
      return "Some";
    if (selected.length === 1)
      return "One";
    return "None";
  }
  async addProductsToCart() {
    for (const button of this.parts.addToCart)
      button.disabled = true;
    this.dataset.isAdding = String(true);
    const products = this.selectedProducts;
    const items = products.map((product) => ({
      quantity: product.items,
      id: product.variantId
    }));
    if (items.length) {
      await addItems({ items });
      await new Promise((resolve) => {
        setTimeout(resolve, 800);
      });
    }
    openCart();
    for (const button of this.parts.addToCart)
      button.disabled = false;
    this.dataset.isAdding = String(false);
  }
  get selectedProducts() {
    return this.parts.folds.map((fold) => fold.selectedProducts).flat();
  }
  get parentProduct() {
    return this.data.parent;
  }
}
customElements.define("accessories-section", Section);
export {
  Section as AccessoriesSection
};
